import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalTitleDiscardAllFromGlobalCreate: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-title-discard-all-from-global-create',
		defaultMessage: 'Are you sure you want to discard and close?',
		description:
			'Warning title for discard suggestions modal, when user clicks [Create] button in the top nav bar.',
	},
	modalBodyDiscardAllFromGlobalCreate: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-body-discard-all-from-global-create',
		defaultMessage: "You're going to lose all suggestions if you continue.",
		description:
			'Warning description for discard suggestions modal, when user clicks [Create] button in the top nav bar.',
	},
	modalTitleDiscardCurrentSuggested: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-title-discard-current-suggested',
		defaultMessage: 'Discard suggestion',
		description:
			'Warning title for discard suggestions modal, when user discards currently opened issue.',
	},
	modalBodyDiscardCurrentSuggested: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-body-discard-current-suggested',
		defaultMessage: 'Are you sure you want to discard this suggestion?',
		description: 'Warning description for discard suggestions modal, when user clicks discard',
	},
	modalTitleDiscardCurrentEdited: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-title-discard-current-edited',
		defaultMessage: "The changes you've made won't be saved",
		description:
			'Warning title for discard suggestions modal, when user clicks selects a different suggested issue, while one is already edited.',
	},
	modalBodyDiscardCurrentEdited: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-body-discard-current-edited',
		defaultMessage: 'Are you sure you want to open another suggestion?',
		description:
			'Warning description for discard suggestions modal, when user clicks selects a different suggested issue, while one is already edited.',
	},
	modalDiscardButton: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-discard-button',
		defaultMessage: 'Discard',
		description: 'Discard button for the Discard Warning modal.',
	},
	modalContinueButton: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-continue-button',
		defaultMessage: 'Continue',
		description: 'Continue button for the Discard Warning modal.',
	},
	modalCancelButton: {
		id: 'issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-cancel-button',
		defaultMessage: 'Cancel',
		description: 'Cancel button for the Discard Warning modal.',
	},
});
